import { render } from "./CaretUp.vue?vue&type=template&id=74001be0"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CaretUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74001be0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74001be0', __exports__)) {
    api.reload('74001be0', __exports__)
  }
  
  module.hot.accept("./CaretUp.vue?vue&type=template&id=74001be0", () => {
    api.rerender('74001be0', render)
  })

}


export default __exports__